export enum ModalId {
  AddCoApplicant,
  AppraisalEmbedded,
  AppraisalRefresh,
  GeicoDiscount,
  MoreDetails,
  SampleTerms,
  SaveSearch,
  SearchBar,
  Shipping,
  SoftPull,
  ComposerUi
}

export enum NativeModalId {
  SoftPull = 'softPull'
}

export enum ComposerModalName {
  SoftPull = 'softpull'
}

export const ModalPriorities = {
  [ModalId.AppraisalEmbedded]: 1,
  [ModalId.AppraisalRefresh]: 1,
  [ModalId.GeicoDiscount]: 2,
  [ModalId.MoreDetails]: 1,
  [ModalId.SampleTerms]: 2,
  [ModalId.SaveSearch]: 1,
  [ModalId.Shipping]: 2,
  [ModalId.SoftPull]: 2
};
